import { create } from 'zustand'

interface NavBadgeState {
  inboxUnread: number
  inboxEscalated: number
  ordersNew: number
  setInboxUnread: (n: number) => void
  setInboxEscalated: (n: number) => void
  setOrdersNew: (n: number) => void
  decrementInboxUnread: (n: number) => void
}

export const useNavBadgeStore = create<NavBadgeState>((set) => ({
  inboxUnread: 0,
  inboxEscalated: 0,
  ordersNew: 0,
  setInboxUnread: (n) => set({ inboxUnread: n }),
  setInboxEscalated: (n) => set({ inboxEscalated: n }),
  setOrdersNew: (n) => set({ ordersNew: n }),
  decrementInboxUnread: (n) => set((s) => ({ inboxUnread: Math.max(0, s.inboxUnread - n) })),
}))
